// extracted by mini-css-extract-plugin
module.exports = {"breakpointTablet":"768px","mortgageInsurance":"MortgageInsuranceCard_mortgageInsurance__H8_1U"};